import { useParams } from "react-router-dom";
import { Form, Button, Input, message } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiClient } from "../Api/AllApi";

const IncreasePayment = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [amount_paid, setAmount_paid] = useState(0);
  const [form1] = Form.useForm();

  // Function to handle form submission
  const PostApi = async () => {
    try {
      let formData = new FormData();
      formData.append("id", id); // Ensure ID is included
      // Send negative value to increase debt
      formData.append("amount", -Math.abs(amount_paid));
      for (const pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
      await apiClient.post(`/customers/pay/${id}`, formData);
      form1.resetFields(); // Reset form on success
      window.location.href = "/GetCustomer";
    } catch (error) {
      console.error("Error:", error);
      message.error("error", error);
    }
  };

  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "50px",
        direction: "rtl", // Right-to-left layout for Arabic and Kurdish
      }}
    >
      <h1 style={{ fontSize: "24px", marginBottom: "20px" }}>
        {t("increaseDebt")} {/* Translated heading */}
      </h1>
      <Form
        form={form1}
        onFinish={PostApi} // Trigger API on form submit
        style={{ fontSize: "18px" }}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 16 }}
      >
        <Form.Item
          name="amount_paid"
          label={
            <span style={{ fontSize: "18px", fontWeight: "bold" }}>
              {t("increaseDebt")}
            </span>
          }
        >
          <Input
            style={{ width: "70%", fontSize: "16px", textAlign: "center" }}
            value={amount_paid}
            onChange={(e) => setAmount_paid(e.target.value)}
          />
        </Form.Item>

        <Form.Item label=".">
          <Button
            type="primary"
            htmlType="submit"
            style={{
              backgroundColor: "orange",
              borderColor: "orange",
              fontSize: "16px",
            }}
          >
            {t("submit")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            type="primary"
            danger
            onClick={() => form1.resetFields()}
            style={{
              backgroundColor: "blue",
              borderColor: "blue",
              fontSize: "16px",
            }}
          >
            {t("reset")}
          </Button>
          <span style={{ margin: "0 8px" }}></span>
          <Button
            type="primary"
            danger
            onClick={() => (window.location.href = "/GetCustomer")}
            style={{
              backgroundColor: "red",
              borderColor: "red",
              fontSize: "16px",
            }}
          >
            {t("cancel")}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default IncreasePayment;
